import type { AppAction } from "../app.types"
import type { Comparison } from "../comparisons/comparison.types"
import type { Project } from "../projects/projects.types"
import type { Group, Student } from "../user/user.types"

export interface IMultiShareState {
  dialogOpen: boolean
  groups: Group[]
  selectedProjects: Project[]
  selectedComparisons: Comparison[]
  selectedGroups: Group[]
}

export enum MultiShareStates {
  BosatlasSelector = 0,
  StudentSelector = 1,
  Overview = 2
}

export type MultiShareActions =
  | MultiShareProjectAction
  | MultiShareComparisonAction
  | MultiShareGroupAction
  | MultiShareGroupListAction
  | MultiShareStudentAction
export type MultiShareProjectAction = AppAction<Project>
export type MultiShareComparisonAction = AppAction<Comparison>
export type MultiShareGroupAction = AppAction<Group>
export type MultiShareGroupListAction = AppAction<Group[]>
export type MultiShareStudentAction = AppAction<Student>
